/* NgRx */
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {AuthenticationState} from './authentication.reducer';


// Selector functions
const authenticationData =
  createFeatureSelector<AuthenticationState>('ss-cord.authentication');

// Get Login Info
export const loginInfo = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.loginInfo
);

// Get Phone Number
export const phoneNumber = createSelector(
  authenticationData,
  (state: AuthenticationState) => ({
    phoneNumber: state.phoneNumber
  })
);

// Get Medication Status
export const hasMedication = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.hasMedication
);

// Get Medical Problems
export const hasMedicalProblems = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.hasMedicalProblems
);

// Get Consent Form
export const consentFormLink = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.consentFormLink
);

// Get Onboarding Step Check details
export const role = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.role
);

export const isUsernameAvailable = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.isUsernameAvailableInfo
);

export const forgotPasswordInfo = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.forgotPasswordInfo
);

export const obQuestionList = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.questionList
);

export const registrationInfo = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.registrationInfo
);

export const generateOtpInfo = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.generateOtpInfo
);

export const verifyOtpInfo = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.verifyOtpInfo
);

export const saveAnswersInfo = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.saveAnswersInfo
);

export const verifyOtpForTfaInfo = createSelector(
  authenticationData,
  (state: AuthenticationState) => state.verifyOtpForTfaInfo
);
